"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FollowButton = _interopRequireDefault(require("eventbrite_design_system/followButton/FollowButton"));

var _FollowLoadingButton = _interopRequireDefault(require("./FollowLoadingButton"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _isInfoReady = function _isInfoReady(isFollowing) {
  return typeof isFollowing === 'boolean';
};

var FollowButtonComponent = /*#__PURE__*/function (_Component) {
  _inherits(FollowButtonComponent, _Component);

  var _super = _createSuper(FollowButtonComponent);

  function FollowButtonComponent() {
    _classCallCheck(this, FollowButtonComponent);

    return _super.apply(this, arguments);
  }

  _createClass(FollowButtonComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          size = _this$props.size,
          __containerClassName = _this$props.__containerClassName,
          isFollowing = _this$props.isFollowing,
          onFollow = _this$props.onFollow,
          onUnFollow = _this$props.onUnFollow,
          organizerName = _this$props.organizerName,
          isDisabled = _this$props.isDisabled;
      var followButtonText = isFollowing ? _constants.FOLLOWING_TEXT : _constants.FOLLOW_TEXT;
      var followButtonDataSpec = isFollowing ? 'following-organizer-button' : 'follow-organizer-button';
      var followButtonAction = isFollowing ? onUnFollow : onFollow;

      if (!_isInfoReady(isFollowing)) {
        return /*#__PURE__*/_react.default.createElement(_FollowLoadingButton.default, {
          size: size
        });
      }

      if (!organizerName) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: __containerClassName
      }, /*#__PURE__*/_react.default.createElement(_FollowButton.default, {
        disabled: isDisabled,
        "data-spec": followButtonDataSpec,
        onClick: followButtonAction,
        style: style,
        size: size,
        isFollowing: isFollowing,
        __containerClassName: __containerClassName
      }, followButtonText));
    }
  }]);

  return FollowButtonComponent;
}(_react.Component);

_defineProperty(FollowButtonComponent, "propTypes", {
  /**
   * Callback for when user clicks to follow
   */
  onFollow: _propTypes.default.func.isRequired,

  /**
   * Callback for when user clicks to unfollow
   */
  onUnFollow: _propTypes.default.func.isRequired,

  /**
   * Whether user is currently following organizer or not
   */
  isFollowing: _propTypes.default.bool,

  /**
   * Whether user can click the button or not
   */
  isDisabled: _propTypes.default.bool,

  /**
   * Name of the organizer
   */
  organizerName: _propTypes.default.string,

  /**
   * Style of Button to be rendered 'standard' or 'solitary'
   */
  style: _propTypes.default.oneOf(_constants.FOLLOW_BUTTON_STYLES),

  /**
   * Size of button 'compact', 'mini' or 'standard'
   */
  size: _propTypes.default.oneOf(_constants.FOLLOW_BUTTON_SIZES),

  /**
   * Class for the container of the button
   */
  __containerClassName: _propTypes.default.string
});

_defineProperty(FollowButtonComponent, "defaultProps", {
  style: 'standard',
  size: 'standard',
  isFollowing: null
});

var _default = FollowButtonComponent;
exports.default = _default;
//# sourceMappingURL=FollowButton.js.map